<span class="bg-light d-inline-block p-1 px-2 border rounded">
  <i class="icon-16-doc-{{ icon }} align-middle"></i>
  <span [tooltip]="filename" class="text-truncate d-inline-block mx-1 align-middle" style="max-width: 200px">
    {{ filename }}
  </span>
  <span *ngIf="bytes">({{ bytes | bytes }})</span>
</span>
